document.addEventListener( 'DOMContentLoaded' , function() {

  const isoButtons = document.querySelectorAll( ".isotope__button" );

  isoButtons.forEach( ( oneButton ) => {
    oneButton.addEventListener( 'click', function() {    
      window.scrollTo({ top: 0, behavior: 'instant' });
    });
  });

});